import { render, staticRenderFns } from "./EsportaDatiPers.vue?vue&type=template&id=628101d1"
import script from "./EsportaDatiPers.vue?vue&type=script&lang=js"
export * from "./EsportaDatiPers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports